import { render } from "./ChordTyper.vue?vue&type=template&id=70e967df"
import script from "./ChordTyper.vue?vue&type=script&lang=js"
export * from "./ChordTyper.vue?vue&type=script&lang=js"

import "./ChordTyper.vue?vue&type=style&index=0&id=70e967df&lang=css"
script.render = render

export default script